import styled, { css } from 'styled-components';
import { Row as GridRow } from 'components/Grid';
import Button from 'components/Button';

export const Container = styled.div`
  max-width: 900px;
  margin-bottom: 150px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Row = styled(GridRow)`
  flex-shrink: 1 !important;
`;

const name = css`
  max-width: 400px;
  font-weight: 600;
  margin-bottom: 16px;
  color: ${({ color }) => color};
`;

export const Name = styled.h3`
  ${name}
`;

Name.xs = styled.h4`
  ${name}
`;

const description = css`
  max-width: 400px;
  margin-bottom: 16px;
  color: #626e75;
`;

export const Description = styled.h5`
  ${description}
`;

Description.xs = styled.p`
  ${description}
`;

export const Image = styled.img`
  width: 100%;
`;

export const GetStarted = styled(Button)`
  width: 170px;
`;
